import { useState, useEffect } from "react";

interface Suggestion {
  projectName: string;
  developerName: string;
  location: string;
  uuid: string;
  projectType: string;
  resultType: string;
}

function useSuggestionsV2(query?: string): {
  data: Suggestion[];
  loading: boolean;
  error: any;
} {
  const [suggestions, setSuggestions] = useState<Suggestion[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!query || query.length < 3) {
      setSuggestions([]);
      setLoading(false);
      return;
    }
    const fetchSuggestions = async () => {
      setLoading(true);
      const response = await fetch(`/api/suggest/v2?terms=${query}`);
      if (response.ok) {
        const data = await response.json();
        setSuggestions(data.suggestions);
      }
      setLoading(false);
    };
    fetchSuggestions()
  }, [query]); // Add query as a dependency to the useEffect hook


  return { data: suggestions, loading, error: null };
}

export default useSuggestionsV2;
